module.exports = __webpack_public_path__ + "media/refer_friend/youre-all-entered-to-win_200x180_@2x-df8bdd2f.png";